import AuthConstants from '../constants/AuthConstants';
import { currentAccountSelector } from '../selectors/AuthSelector';
import composeFailureMessaging from '../helpers/messaging/composeFailureMessaging';
import composeGlobalFailureMessaging from '../helpers/messaging/composeGlobalFailureMessaging';

/**
 * Checks if this action is protected with Authentication and if its then dispatch an action to show
 * modal.
 *
 * @param {object} apiClient
 */
export default function authMiddleware(store) {
  return next => action => {
    const { middlewareData } = action;
    const auth = store.getState().get('auth');

    if (
      __CLIENT__ &&
      middlewareData &&
      (middlewareData.authRequired || middlewareData.accountRequired) &&
      !auth.get('currentUserId')
    ) {
      return next({
        type: AuthConstants.OPEN_LOGIN_DIALOG,
        payload: { postLoginAction: action }
      });
    }

    if (__CLIENT__ && middlewareData && middlewareData.accountRequired && !currentAccountSelector(store.getState())) {
      const err = { classification: 'requiresLibraryAccount' };
      const payload = action.payload || {};
      const messagingId = action.messagingId || payload.id || action.id; // TODO: only support action.messagingId

      return next({
        type: AuthConstants.REQUIRES_LIBRARY_ACCOUNT,
        id: payload.id || action.id,
        messaging: messagingId ? composeFailureMessaging(messagingId, err) : composeGlobalFailureMessaging(err)
      });
    }

    return next(action);
  };
}
